import { FunctionComponent } from "react";

import { CreateMapForm } from "@/pages/Private/pages/Map/components/CreateMapForm";
import { ListSourceType } from "@/enum/list.enum";

import { CustomEvent } from "@/pages/Private/pages/CustomEvent/schema/customEvent";
import { Map } from "@/pages/Private/pages/Map/schema/map";
import { CsvEnrichment } from "@/pages/Private/pages/CsvEnrichment/schema/csvEnrichment";
import { Job } from "@/pages/Private/pages/Job/schema/job";
import { LiCompanyActivity } from "@/pages/Private/pages/LiCompanyActivity/schema/liCompanyActivity";
import { LiEvent } from "@/pages/Private/pages/LiEvent/schema/liEvent";
import { LiPeople } from "@/pages/Private/pages/LiPeople/schema/liPeople";
import { LiPost } from "@/pages/Private/pages/LiPost/schema/liPost";
import { LiProfileVisits } from "@/pages/Private/pages/LiProfileVisits/schema/liProfileVisits";

import { LiSn } from "@/pages/Private/pages/LiSn/schema/liSn";

import { StepInfo } from "@/components/StepInfo/StepInfo";

import { AddedSourceList } from "../../../components/AddedSourceList";
import { List } from "../../../schema/list";
import { FundingMa } from "../../../../FundingMa/schema/funding-ma";
import { Swarm } from "../../../../Swarm/schema/swarm";

export interface MapsSourceProps {
	data: List;
	duplicated:
		| Map
		| Job
		| CsvEnrichment
		| LiEvent
		| LiCompanyActivity
		| LiPost
		| LiProfileVisits
		| LiPeople
		| LiSn
		| FundingMa
		| Swarm
		| null;
	selected:
		| Map
		| Job
		| CsvEnrichment
		| LiEvent
		| LiCompanyActivity
		| LiPost
		| LiProfileVisits
		| LiPeople
		| LiSn
		| CustomEvent
		| FundingMa
		| Swarm
		| null;
	setDuplicated: (
		map:
			| Map
			| Job
			| CsvEnrichment
			| LiEvent
			| LiCompanyActivity
			| LiPost
			| LiProfileVisits
			| LiPeople
			| LiSn
			| FundingMa
			| Swarm
			| null
	) => void;
	setSelected: (
		map:
			| Map
			| Job
			| CsvEnrichment
			| LiEvent
			| LiCompanyActivity
			| LiPost
			| LiProfileVisits
			| LiPeople
			| LiSn
			| CustomEvent
			| FundingMa
			| Swarm
			| null
	) => void;
}

export const MapsSource: FunctionComponent<MapsSourceProps> = ({
	data,
	duplicated,
	selected,
	setDuplicated,
	setSelected,
}) => {
	if (data.sourceType === ListSourceType.MAPS) {
		return (
			<>
				<StepInfo
					description={
						<>
							<p>
								Signalist.io lets you name a list, enter your Google Maps keyword and desired
								locations, then specify which roles and regions to target (with fallback options if
								needed). You simply cap how many people to find, set any ICP criteria, and choose
								the extraction frequency and email fields to automate your outreach.
							</p>
						</>
					}
					title="Build a list of Google Maps local businesses"
					videoId="lPTZ5uoQLOQ"
				/>
				<div className="flex flex-row gap-12">
					<div className="grow relative">
						{duplicated ? (
							<CreateMapForm
								handleDuplicate={setDuplicated}
								handleSelect={setSelected}
								list={data as List}
								map={duplicated as Map}
							/>
						) : selected ? (
							<CreateMapForm handleSelect={setSelected} list={data as List} map={selected as Map} />
						) : (
							<CreateMapForm list={data as List} />
						)}
					</div>
					<div className="w-1/2">
						<AddedSourceList
							handleDuplicate={(item) => {
								setDuplicated(item);
								setSelected(null);
							}}
							handleSelect={(item) => {
								setSelected(item);
								setDuplicated(null);
							}}
							list={data as List}
						/>
					</div>
				</div>
			</>
		);
	}

	return <></>;
};
